import { Injectable } from '@angular/core';
import { Toast, ToastServiceInterface } from './toast.service.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToastService implements ToastServiceInterface {
  private DEFAULT_TIMEOUT = 3000;
  private toastsSubject = new BehaviorSubject<Toast[]>([]);
  public toasts$ = this.toastsSubject.asObservable();

  showToast({ type, message, duration = this.DEFAULT_TIMEOUT }: Omit<Toast, 'id'>): void {
    const id = crypto.randomUUID();
    this.toastsSubject.next([...this.toastsSubject.value, { type, message, id, duration }]);

    if (duration !== 0) {
      setTimeout(() => this.removeToast(id), duration);
    }
  }

  removeToast(id: string): void {
    const currentToasts = this.toastsSubject.value;
    this.toastsSubject.next(currentToasts.filter((t) => t.id !== id));
  }
}
